<template>
  <div>
    <fieldset>
      <legend>
        {{ $t('Add your business details') }}
      </legend>

      <CompanyAuBusinessEntityDetailsForm v-model:business-entity="internalBusinessEntity" />
    </fieldset>

    <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
    <SubmitButton :text="$t('Save')" auto-submit class="tw-mt-5" />
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { ref } from 'vue'
import CompanyAuBusinessEntityDetailsForm from '@/components/compliances/BusinessEntity/Au/CompanyAuBusinessEntityDetailsForm.vue'

export default {
  name: 'CompanyAuBusinessEntityForm',
  components: {
    CompanyAuBusinessEntityDetailsForm,
  },
  props: {
    businessEntity: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const v$ = useVuelidate()
    const internalBusinessEntity = ref(props.businessEntity)

    return {
      internalBusinessEntity,
      v$,
    }
  },
}
</script>
